import { formatDate } from "../../../../functions/dateTime/formatDate";

import StageStatusBadge from "./StageStatusBadge";
import CheckpointView from "../../components/jobcard-history/result/CheckpointView";

const StageDetails = ({ stage, stageData }) => {
  return (
    <div className="w-[60%] shadow-200 rounded-xl bg-white p-4">
      <div className="flex justify-between items-center">
        <span className="text-gray-500">
          STAGE: {stage.id}
        </span>

        <StageStatusBadge status={stageData?.status} />
      </div>

      <h3 className="text-light-black font-medium">
        {stage.name}
      </h3>

      <div className="max-lg:text-xs flex justify-between border-b pb-3">
        <p className="text-gray-500">
          Started at: {formatDate(stageData?.startedAt)}
        </p>

        <p className="text-gray-500">
          Completed at: {formatDate(stageData?.completedAt)}
        </p>
      </div>

      <div className="p-3 pb-0 max-h-[450px] overflow-auto">
        <CheckpointView
          checkpointsData={stageData?.checkpointUpdates}
          status={stageData?.status}
          stageId={stage.id}
        />
      </div>
    </div>
  );
};

export default StageDetails;